export default {
  "feature-page": () => import("/home/vsts/work/1/s/webapp-ots-nuxt/layouts/feature-page.vue"),
  "text-only": () => import("/home/vsts/work/1/s/webapp-ots-nuxt/layouts/text-only.vue")
}